import {
  API_ERROR,
  PURCHASE_INDENTS_LIST,
  PURCHASE_INDENTS_LIST_SUCCESS,
  PURCHASE_INDENTS_LIST_CHECKED,
  ALL_PURCHASE_INDENTS_LIST_CHECKED,
  RFQ_SELECTED_ITEM,
  RFQ_SELECTED_ALL_VENDORS,
  RFQ_SELECTED_VENDORS,
  CELAR_VENDORS,
  VENDORS_LIST,
  VENDORS_LIST_SUCCESS,
  GET_VENDORS_DATA,
  VENDORS_DATA_SUCCESS,
  RFQ_LIST,
  RFQ_LIST_SUCCESS,
  RFQ_LIST_COUNT,
  RFQ_LIST_COUNT_SUCCESS,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  RFQ_ROW_DATA,
  RFQ_ROW_DATA_SUCCESS,
  REQUESTFORQUOTATION_ADD,
  DOWNLOAD_RFQ_BUTTON,
  RF_MODEL_LIST_OPEN,
  RF_MODEL_LIST_CLOSE,
  LIST_LAYOUT,
  TOGGLE_ITEM_MENU,
  GENERATE_RFQ_PDF,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  ADD_VENDORS,
  TOOLTI_OPEN,
  PI_DETAILS_MODEL_OPEN,
  PI_DETAILS_MODEL_CLOSE,
  PI_ROW_DATA_SUCCESS,
  MR_CODE_DETAILS,
  MR_CODE_DETAILS_SUCCESS,
  ADD_VENDORS_MODEL_CLOSE,
  ADD_VENDORS_MODEL_OPEN,
  MR_ITEM_IMAGES,
  MR_ITEM_IMAGES_SUCCESS,
  PI_MR_ITEM_IMAGES_MODEL_CLOSE,
  RFQ_PI_ITEM_CANCEL,
} from "./actionTypes";
export const getPurchaseIndentItems = (data) => {
  return {
    type: PURCHASE_INDENTS_LIST,
    payload: { data },
  };
};
export const getPuchaseIndentItemsSuccessful = (response) => {
  return {
    type: PURCHASE_INDENTS_LIST_SUCCESS,
    payload: response,
  };
};
export const PuchaseIndentItemsChecked = (checked, item, index) => {
  return {
    type: PURCHASE_INDENTS_LIST_CHECKED,
    payload: { checked, item, index },
  };
};
export const AllPuchaseIndentItemsChecked = (checked) => {
  return {
    type: ALL_PURCHASE_INDENTS_LIST_CHECKED,
    payload: { checked },
  };
};
export const RFQSelectedItems = (checked, item) => {
  return {
    type: RFQ_SELECTED_ITEM,
    payload: { checked, item },
  };
};
export const RFQSelectedAllVendors = (checked) => {
  return {
    type: RFQ_SELECTED_ALL_VENDORS,
    payload: { checked },
  };
};
export const RFQSelectedVendors = (checked, vend, index) => {
  return {
    type: RFQ_SELECTED_VENDORS,
    payload: { checked, vend, index },
  };
};
export const ClearVendors = () => {
  return {
    type: CELAR_VENDORS,
  };
};
export const getRFQRequestList = (data) => {
  return {
    type: RFQ_LIST,
    payload: { data },
  };
};
export const RFQRequestListSuccessful = (response) => {
  return {
    type: RFQ_LIST_SUCCESS,
    payload: response,
  };
};
export const getRFQListcount = (data) => {
  return {
    type: RFQ_LIST_COUNT,
    payload: { data },
  };
};
export const RFQListCountSuccessful = (request) => {
  return {
    type: RFQ_LIST_COUNT_SUCCESS,
    payload: request,
  };
};
export const addVendorsModelOpen = (RFQId) => {
  return {
    type: ADD_VENDORS_MODEL_OPEN,
    payload: { RFQId },
  };
};
export const addVendorsModel_close = () => {
  return {
    type: ADD_VENDORS_MODEL_CLOSE,
  };
};
export const getVendorsList = (data, addVendors, clearVendlist = false) => {
  return {
    type: VENDORS_LIST,
    payload: { data, addVendors, clearVendlist },
  };
};
export const VendorsListSuccessful = (response) => {
  return {
    type: VENDORS_LIST_SUCCESS,
    payload: response,
  };
};
export const getVendorData = (VendId) => {
  return {
    type: GET_VENDORS_DATA,
    payload: { VendId },
  };
};
export const VendorDataSuccessful = (response) => {
  return {
    type: VENDORS_DATA_SUCCESS,
    payload: response,
  };
};
export const addRFQRequest = (data) => {
  return {
    type: REQUESTFORQUOTATION_ADD,
    payload: { data },
  };
};
export const downloadRFQButton = (RFQId) => {
  return {
    type: DOWNLOAD_RFQ_BUTTON,
    payload: { RFQId },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelectChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getRFQRequestdata = (rfqId) => {
  return {
    type: RFQ_ROW_DATA,
    payload: { rfqId },
  };
};
export const getRFQRequestdataSuccessful = (request) => {
  return {
    type: RFQ_ROW_DATA_SUCCESS,
    payload: request,
  };
};
export const rf_model_list_open = (rfqId) => {
  return {
    type: RF_MODEL_LIST_OPEN,
    payload: { rfqId },
  };
};

export const rf_model_list_close = () => {
  return {
    type: RF_MODEL_LIST_CLOSE,
  };
};

export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const generateRFQasPDF = (RFQId) => {
  return {
    type: GENERATE_RFQ_PDF,
    payload: { RFQId },
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const addVendors = (data, rfqId) => {
  return {
    type: ADD_VENDORS,
    payload: { data, rfqId },
  };
};

export const tooltipOpen = (Item) => {
  return {
    type: TOOLTI_OPEN,
    payload: { Item },
  };
};
export const PIDetailsModel_open = (PIID) => {
  return {
    type: PI_DETAILS_MODEL_OPEN,
    payload: { PIID },
  };
};

export const PIDetailsModel_close = () => {
  return {
    type: PI_DETAILS_MODEL_CLOSE,
  };
};

export const PIRowDataSuccessful = (response) => {
  return {
    type: PI_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getMRCodeDetails = (ItemId) => {
  return {
    type: MR_CODE_DETAILS,
    payload: { ItemId },
  };
};
export const getMRCodeDetailsSuccessful = (response) => {
  console.log("Hello World");
  return {
    type: MR_CODE_DETAILS_SUCCESS,
    payload: response,
  };
};
export const getMRItemImges = (PIItemId) => {
  return {
    type: MR_ITEM_IMAGES,
    payload: { PIItemId },
  };
};
export const getMRItemImgesSuccessful = (response) => {
  return {
    type: MR_ITEM_IMAGES_SUCCESS,
    payload: response,
  };
};
export const PIMRItemImagesModel_close = () => {
  return {
    type: PI_MR_ITEM_IMAGES_MODEL_CLOSE,
    payload: null,
  };
};
export const PIitemCancel = (data) => {
  return {
    type: RFQ_PI_ITEM_CANCEL,
    payload: { data },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
